import { Heading, Icon, Theme, useStyles } from 'bold-ui'
import { AccordionAnimation } from 'components/accordion/AccordionAnimation'
import { AccordionButton } from 'components/accordion/AccordionButton'
import React from 'react'
import { AccordionItemPanel } from 'react-accessible-accordion'

export interface NewsSectionProps {
  title: React.ReactNode
  children: React.ReactNode
}

export function NewsSection(props: NewsSectionProps) {
  const { title, children } = props
  const { classes } = useStyles(createStyles)

  return (
    <AccordionAnimation>
      <AccordionButton>
        <div className={classes.accordion}>
          <Heading level={2} style={classes.title}>
            {title}
          </Heading>
          <Icon icon='angleDown' size={1.5} className={classes.icon} />
        </div>
      </AccordionButton>
      <AccordionItemPanel>
        <div style={{ padding: '0.5rem' }}>{children}</div>
      </AccordionItemPanel>
    </AccordionAnimation>
  )
}
const createStyles = (theme: Theme) => ({
  accordion: {
    ...theme.typography.variant('h2'),
    display: 'flex',
    borderRadius: 2,
    background: theme.pallete.gray.c90,
    '&:hover': {
      backgroundColor: theme.pallete.gray.c80,
    },
    height: 40,
  },
  title: {
    flex: 1,
    padding: '0.25rem 0.75rem',
  },
  icon: {
    alignSelf: 'center',
    marginRight: '0.5rem',
  },
  content: {
    padding: '1rem 0.3rem',
  },
})
